var tri = require("tripartite"); var t = "\t\t<span class=\"cancel-operation material-icons\" title=\"cancel\">\n\t\t\tcancel\n\t\t<\/span>"; 
module.exports = tri.addTemplate("@webhandle/event-notification-panel/panels/cancel-button", t); 